import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';

import { routes } from './app.routes';
import { headerInterceptor } from './core/http.interceptor';
import { AuthService } from './core/auth.service';
import { UserService } from './user/user.service';
import { QaService } from './qa/qa.service';
import { OrderService } from './order/order.service';
import { SourceService } from './source/source.service';
import { SnackBarService } from './core/snack-bar.service';
import { SettingService } from './setting/setting.service';
import { CourseService } from './course/course.service';
import { CategoryService } from './category/category.service';
import { FaqService } from './faq/faq.service';
import { CommentService } from './comment/comment.service';
import { NavigationService } from './navigation/navigation.service';
import { TopicService } from './topic/topic.service';
import { PageService } from './page/page.service';
import { PackageService } from './package/package.service';
import { PromoService } from './promo/promo.service';
import { LogService } from './log/log.service';
import { SystemMessageService } from './system-message/system-message.service';
import { LanguageService } from './common/language/language.service';
import { ObserverService } from './observer/observer.service';
import { IncomeService } from './income/income.service';
import { SkladchinaService } from './skladchina/skladchina.service';
import { MailService } from './mail/mail.service';
import { MassService } from './mass/mass.service';
import { AdminLogService } from './admin-log/admin-log.service';
import { PushSubscriptionsService } from './push-subscriptions/push-subscriptions.service';
import { ImageService } from './core/image.service';
import { GoogleIndexService } from './core/google-index.service';
import { ChatService } from './core/chat.service';
import { RelationService } from './course/relation/relation.service';
import { provideQuillConfig } from 'ngx-quill/config';
import { quillDefaultModules } from './common/quill/quill-modules';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withHashLocation(),
    ),
    provideHttpClient(
      withInterceptors([headerInterceptor])
    ),
    provideQuillConfig({
      modules: quillDefaultModules
    }),
    provideAnimations(),
    importProvidersFrom(MatNativeDateModule),
    AuthService,
    UserService,
    QaService,
    OrderService,
    SourceService,
    SnackBarService,
    SettingService,
    CourseService,
    CategoryService,
    FaqService,
    CommentService,
    NavigationService,
    TopicService,
    PageService,
    PackageService,
    PromoService,
    LogService,
    SystemMessageService,
    LanguageService,
    ObserverService,
    IncomeService,
    SkladchinaService,
    MailService,
    MassService,
    AdminLogService,
    PushSubscriptionsService,
    ImageService,
    GoogleIndexService,
    ChatService,
    RelationService
  ]
};